module.exports = __webpack_public_path__ + "assets/img/3.dee6e923.jpg";